import { convertToUserTimezone } from "@/utils/convertToUserTimezone";

export const formatAgendaTableDate = (date: string) => {
  if (!date) {
    return "";
  }
  // This is a fixed format on purpose according with Design specifications
  return new Date(date).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
};

const toUserLocalTime = (date?: string, time?: string | null) => {
  if (!date || !time) return "";

  const datePart = date.split("T")[0];
  const userDateTime = new Date(convertToUserTimezone(`${datePart}T${time.slice(0, 5)}:00Z`));

  return `${userDateTime.getUTCHours().toString().padStart(2, "0")}:${userDateTime.getUTCMinutes().toString().padStart(2, "0")}`;
};

export const formatAgendaTableTime = (startDate?: string, startTime?: string | null, endDate?: string, endTime?: string | null) => {
  if (!startDate || !startTime || !endDate || !endTime) {
    return "-";
  }

  return `${toUserLocalTime(startDate, startTime)} - ${toUserLocalTime(endDate, endTime)}`;
};
